import type { ScheduledScreenshotWatcher } from './ScheduledScreenshotWatcher';
import type { PavilionCoordinator } from '../pavilion/PavilionCoordinator';
import { machineIdState } from '../../api/stores/shared';
import { serviceContainer } from '../../services/ServiceContainer';
import { websocket, HostMessageType } from '@playcastdotio/Messaging';

/**
 * Wires ScheduledScreenshotWatcher events to realtime-api reporting.
 * Extracted from init.ts for file-size compliance.
 */
export function wireScheduledWatcherEvents(
  watcher: ScheduledScreenshotWatcher,
  pavilion: PavilionCoordinator,
): void {
  watcher.events.watcherMismatchDetected.addListener((data) => {
    console.log('[Coordinators] Scheduled watcher mismatch detected — triggering restart', data);
    pavilion.handleWatcherMismatch(data.campaignId);

    const machineId = machineIdState.currentState;
    if (machineId) {
      serviceContainer.realtimeService.sendMessage(
        websocket.generators.host(HostMessageType.HOST_SCHEDULED_WATCHER_RESTART_REPORT, {
          machineId,
          campaignId: data.campaignId,
          expectedHash: data.expectedHash,
          actualHash: data.actualHash,
          hammingDistance: data.hammingDistance,
          tolerance: data.tolerance,
          restartedAt: Date.now(),
        }),
      );
      serviceContainer.realtimeService.sendMessage(
        websocket.generators.host(HostMessageType.HOST_SCHEDULED_WATCHER_CHECK_REPORT, {
          machineId,
          campaignId: data.campaignId,
          passed: false,
          hammingDistance: data.hammingDistance,
          tolerance: data.tolerance,
          checkedAt: Date.now(),
        }),
      );
    }
  });

  watcher.events.watcherCheckPassed.addListener((data) => {
    const machineId = machineIdState.currentState;
    if (machineId) {
      const config = pavilion.getCampaignConfig();
      const tolerance = config?.scheduledWatcher?.hashTolerance ?? 20;
      serviceContainer.realtimeService.sendMessage(
        websocket.generators.host(HostMessageType.HOST_SCHEDULED_WATCHER_CHECK_REPORT, {
          machineId,
          campaignId: data.campaignId,
          passed: true,
          hammingDistance: data.hammingDistance,
          tolerance,
          checkedAt: Date.now(),
        }),
      );
    }
  });
}
